import { DiscoveryChannel } from '@store/discoveryRuns/types'

// Display order for the first-run setup form's channel rows, per the
// confirmed 2026-07-15 prototype capture (TikTok, Instagram, then YouTube
// disabled "Not in this brief").
export const CHANNEL_ORDER: DiscoveryChannel[] = ['tiktok', 'instagram', 'youtube']

// Default (starting) creator count for each channel's stepper. Per Ted's
// design feedback (2026-07-15 prototype review): TikTok 8, Instagram 6.
// YouTube never appears enabled in the reference captures, so its default
// is a reasonable placeholder pending a real per-channel figure from
// Platform.
export const CHANNEL_DEFAULT_COUNTS: Record<DiscoveryChannel, number> = {
  tiktok: 8,
  instagram: 6,
  youtube: 5,
}

// Per-channel creator count ceiling — product decision (Ted, 2026-07-16):
// deliberately one constant so it's easy to tune later. BE enforces the
// same limit in StartDiscoveryRunHandler::MAX_CREATOR_COUNT_PER_CHANNEL —
// keep the two in sync.
export const CHANNEL_MAX_COUNT = 10

export const CHANNEL_MAX_COUNTS: Record<DiscoveryChannel, number> = {
  tiktok: CHANNEL_MAX_COUNT,
  instagram: CHANNEL_MAX_COUNT,
  youtube: CHANNEL_MAX_COUNT,
}

// Minimum creator count while a channel is enabled — toggling off is the
// "I don't want this channel" affordance, not dragging the stepper to 0.
export const CHANNEL_MIN_COUNT = 1

// Reuses the existing platform-filter i18n labels (creatorSearch.filter.platform.*)
// rather than inventing new ones, mirroring utils/channelCounts.ts's
// CHANNEL_LABEL_KEYS.
export const CHANNEL_LABEL_KEYS: Record<DiscoveryChannel, string> = {
  instagram: 'creatorSearch.filter.platform.instagram',
  tiktok: 'creatorSearch.filter.platform.tiktok',
  youtube: 'creatorSearch.filter.platform.youtube',
}

// Mirrors FilterBar/PlatformPills.tsx's PROVIDER_GLYPH mapping.
export const CHANNEL_GLYPHS: Record<DiscoveryChannel, string> = {
  instagram: 'social-instagram-colour',
  tiktok: 'social-tiktok-colour',
  youtube: 'social-youtube-colour',
}
